export const ROLE_STATUS = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
};
